// extracted by mini-css-extract-plugin
export default {"root":"ConfirmCodeForm_root__0M+M0","input":"ConfirmCodeForm_input__MTqdA"};